/**
 * ProductSEO section
 * 
 * This class is responsible for handling the SEO data for the product page.
 * It listens for the `astr-previous-collection` event dispatched from the Breadcrumbs component
 * and initializes the section with the collection data.
 */
export default class ProductSEO {
  collectionData;
  menuData;

  constructor() {
    this.collectionData = null;
    this.menuData = null;

    this.elements = {
      productSEOContainer: document.querySelector('section .product-seo .container'),
    };

    if (this.elements.productSEOContainer) {
      document.addEventListener('astr-previous-collection', (e) => {
        if (typeof e.detail.data === 'undefined' || e.detail.data === null) {
          return;
        }
  
        this.collectionData = e.detail.data;
        this.initSection();
      });
    }
  }

  pullCollectionMenu = () => {
    return new Promise((resolve) => {
      try {
        // Wasn't able to use https://shopify.dev/docs/api/ajax/section-rendering
        $.ajax({
          url: `${window.location.origin}/collections/${this.collectionData.handle}`,
          dataType: 'html',
          method: 'get',
        }).done((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const json_element = doc.querySelector('[data-collection-sub-categories-json]');
          const menu_data = (json_element && json_element.textContent.length > 0) ? JSON.parse(json_element.textContent) : [];
          this.menuData = menu_data;

          resolve(true);
        });
      } catch (error) {
        console.log('Cannot load the menu associated to the collection', error);
        resolve(null);
      }
    });
  };

  initSection = async () => {
    if (!this.collectionData) {
      console.log('No collection data found for SEO');
      return;
    }

    await this.pullCollectionMenu();

    if (!this.menuData || this.menuData.length === 0) {
      console.log('No menu data found for SEO', this.collectionData);

      if (this.collectionData.handle === 'shop-all') {
        return;
      }

      // Fallback to the shop all collection
      this.collectionData = {
        title: 'Shop All',
        handle: 'shop-all',
      };

      await this.initSection();
      return;
    }

    const pathname_parts = window.location.pathname.split('/'); // ['', ('en-gb'), 'products', 'evetta-top']
    let url_locale = '';
    if (pathname_parts[1] !== 'products') {
      url_locale = `/${pathname_parts[1]}`; // for example: /en-gb
    }

    let seo_html = `
      <h4 class="product-seo__title">
        <a href="${url_locale}/collections/${this.collectionData.handle}">Shop more ${(this.collectionData.handle === 'shop-all') ? '' : this.collectionData.title}</a>
      </h4>
      <ul class="product-seo__list">
    `;

    this.menuData.map(item => {
      if (typeof item.url === 'undefined' || item.url === '') {
        return;
      }

      // Add each menu item to the SEO section
      const menu_item_url = `${url_locale}${item.url}`;
      seo_html += `
        <li class="product-seo__item">
          <a href="${menu_item_url}">${item.title}</a>
        </li>`;
    });

    seo_html += `
      </ul>
    `;

    this.elements.productSEOContainer.innerHTML = seo_html;
  };
}
